import { useUser } from '@clerk/clerk-react';
import { useEffect } from 'react';
import { UsersAPI } from '../../api';

export function useUserSync() {
  const { user, isLoaded } = useUser();

  useEffect(() => {
    async function syncUser() {
      if (!isLoaded || !user) return;

      try {
        // Sincronizar usuario usando la API
        const syncResult = await UsersAPI.syncFromClerk({
          id: user.id,
          emailAddresses: user.emailAddresses || [],
          firstName: user.firstName || undefined,
          lastName: user.lastName || undefined,
          imageUrl: user.imageUrl || undefined,
        });
        
        if (syncResult.success) {
          console.log('Usuario sincronizado:', syncResult.message);
          
          // Si es un usuario nuevo, enviar correos de notificación
          if (syncResult.isNewUser) {
            try {
              const primaryEmail = user.primaryEmailAddress?.emailAddress || 
                                 (user.emailAddresses && user.emailAddresses.length > 0 ? user.emailAddresses[0].emailAddress : '');
              
              if (primaryEmail) {
                await fetch('/api/send-welcome-email', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    userEmail: primaryEmail,
                    userName: user.fullName || user.firstName || 'Nuevo Usuario',
                  }),
                });
                console.log('Notificación de nuevo usuario enviada');
              }
            } catch (emailError) {
              console.error('Error enviando notificación de nuevo usuario:', emailError);
            }
          }
        } else {
          console.error('Error sincronizando usuario:', syncResult.error);
        }
      } catch (error) {
        console.error('Error sincronizando usuario:', error);
      }
    }

    syncUser();
  }, [user, isLoaded]);
}